"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var isWeekdayIndex = exports.isWeekdayIndex = function isWeekdayIndex(value) {
  return [0, 1, 2, 3, 4, 5, 6].indexOf(value) > -1;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@alife/next/lib/_components/@alife/next-calendar/lib/utils/validators.js
// module id = 160
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11